export class ConversationReferrer {
  static readonly nonFcr = 'non-fcr';
  static readonly evaluationResult = 'evaluation-result';
  static readonly myTasks = 'my-tasks';
  static readonly tempQuery = 'temp-query';
  static readonly coachingDashboard = 'coaching-dashboard';
  static readonly userEvaluationList = 'user-evaluation-list';
}
